import { Component } from '@angular/core';
import {Router} from "@angular/router";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-home-search',
  imports: [
    FormsModule,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    TranslatePipe
  ],
  templateUrl: './home-search.component.html',
  styleUrl: './home-search.component.scss'
})
export class HomeSearchComponent {
  searchForm: FormGroup;
  skuForm: FormGroup;
  constructor(private router: Router , private fb: FormBuilder) {
    this.searchForm = this.fb.group({
      search: ['', []]
    })
    this.skuForm = this.fb.group({
      sku: ['', []]
    })
  }
  search() {
    if (this.searchForm.controls['search'].value) {
        this.router.navigate(['/assets'], { queryParams: { q: this.searchForm.controls['search'].value } }).then();
    }
  }
  searchSKU() {
    if (this.skuForm.controls['sku'].value) {
      this.router.navigate(['/assets'], { queryParams: { sku: this.skuForm.controls['sku'].value } }).then();
    }
  }

}
